import styled from 'styled-components';

export const MESSAGE_TYPE_MAP = {
    INFO: {
        backgroundColor: '#F3F8FA',
        border: '1px solid #3179AD',
        color: '#3179AD',
    },
    SUCCESS: {
        backgroundColor: '#F5FAF7',
        border: '1px solid #41A667',
        color: '#41A667',
    },
    WARNING: {
        backgroundColor: '#FFFBF2',
        border: '1px solid #FFB300',
        color: '#FFB300',
    },
    ERROR: {
        backgroundColor: '#FEF4F5',
        border: '1px solid #E82E41',
        color: '#E82E41',
    },
};

export const MessageContainer = styled.div`
    margin: 0;
    padding: ${({ padding }) => padding};
    background: ${({ type }) => MESSAGE_TYPE_MAP[type].backgroundColor};
    border: ${({ type }) => MESSAGE_TYPE_MAP[type].border};
    display: flex;
    align-items: flex-start;
`;

export const MessageIcon = styled.div`
    position: absolute;
    left: 12px;
    height: 22px;
    font-size: 20px;
    color: ${({ type }) => MESSAGE_TYPE_MAP[type].color};
`;

export const MessageButtonContainer = styled.div`
    position: absolute;
    right: 8px;
    height: 22px;
`;
